import { Component, Input, ViewEncapsulation } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-delegated-welcome-body",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./delegated-welcome-body.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class DelegatedWelcomeBodyComponent {
  @Input() userName = "there";
}
